import "../../LogoSlider.css";
import { useEffect } from 'react';
import logo_nomanejes_img from '../../images/banner/logo_nomanejes.svg';
import logo_puertoricocartransfer_img from '../../images/banner/logo_puertoricocartransfer.svg';
import logo_carrosacentroamerica_img from '../../images/banner/logo_carrosacentroamerica.svg';
import logo_prautotransport_img from '../../images/banner/logo_prautotransport.svg';
import logo_carmoversus_img from '../../images/banner/logo_carmoversus.svg';
import logo_shipshippersusa_img from '../../images/banner/logo_shipshippersusa.svg';
import logo_ratesautotransport_img from '../../images/banner/logo_ratesautotransport.svg';
import logo_tucarroporusa_img from '../../images/banner/logo_tucarroporusa.svg';
import logo_tcpamerica_img from '../../images/banner/logo_tcpamerica.svg';

import logo_ally_centraldispatch_img from '../../images/banner/logo_ally_centraldispatch.svg';
import logo_ally_seaboard_img from '../../images/banner/logo_ally_seaboardmarine.svg';
import logo_ally_trailerbridge_img from '../../images/banner/logo_ally_trailerbridge.svg';
import logo_crowley_img from '../../images/banner/logo_ally_crowley.svg';
import logo_interport_img from '../../images/banner/logo_ally_interport.svg';
import logo_cmacgm_img from '../../images/banner/logo_ally_cmacgm.svg';

import logo_visa_img from '../../images/banner/logo_payment_visa.svg';
import logo_mastercard_img from '../../images/banner/logo_payment_mastercard.svg';
import logo_americanexpress_img from '../../images/banner/logo_payment_americanexpress.svg';


const logos = {
    logo_nomanejes: { src: logo_nomanejes_img, alt: "Logo Nomanejes", href: "https://www.nomanejes.com" },
    logo_puerto_rico_car_transfer: { src: logo_puertoricocartransfer_img, alt: "Logo Puerto Rico Car Transfer", href: "https://www.puertoricocartransfer.com" },
    logo_carro_a_centro_america: { src: logo_carrosacentroamerica_img, alt: "Logo Carro a Centro America", href: "https://www.carrosacentroamerica.com" },
    logo_pr_autotransport: { src: logo_prautotransport_img, alt: "Logo PR Autotransport", href: "https://www.prautotransport.com" },
    logo_carmoversus: { src: logo_carmoversus_img, alt: "Logo Carmoversus", href: "https://www.carmoversus.com" },
    logo_shipshippersusa: { src: logo_shipshippersusa_img, alt: "Logo Shipshippers USA", href: "https://www.shipshippersusa.com" },
    logo_ratesautotransport: { src: logo_ratesautotransport_img, alt: "Logo Rates Autotransport", href: "https://www.ratesautotransport.com" },
    logo_tucarroporusa: { src: logo_tucarroporusa_img, alt: "Logo Tu Carro Por Usa", href: "https://www.tucarroporusa.com" },
    logo_tcpamerica: { src: logo_tcpamerica_img, alt: "Logo TCP America", href: "https://www.tucarroporamerica.com" },
}

const logos_ally = {
    logo_ally_centraldispatch: { src: logo_ally_centraldispatch_img, alt: "Logo Ally Central Dispatch", href: "https://www.centraldispatch.com" },
    logo_ally_seaboard: { src: logo_ally_seaboard_img, alt: "Logo Ally Seaboard", href: "https://www.seaboardmarine.com" },
    logo_ally_trailerbridge: { src: logo_ally_trailerbridge_img, alt: "Logo Ally Trailer Bridge", href: "https://www.trailerbridge.com" },
    logo_crowley: { src: logo_crowley_img, alt: "Logo Crowley", href: "https://www.crowley.com" },
    logo_interport: { src: logo_interport_img, alt: "Logo Interport", href: "https://interporthouston.com" },
    logo_cmacgm: { src: logo_cmacgm_img, alt: "Logo CMACGM", href: "https://www.cmacgm-group.com" },
}

const logos_payments = {
    logo_visa: { src: logo_visa_img, alt: "Logo Visa", href: "https://www.visa.com" },
    logo_mastercard: { src: logo_mastercard_img, alt: "Logo Mastercard", href: "https://www.mastercard.com" },
    logo_americanexpress: { src: logo_americanexpress_img, alt: "Logo Paypal", href: "https://www.americanexpress.com" },
}


export default function BannerLogosMobile() {
    useEffect(() => {
        const logoContainer = document.getElementById("logo-container");
        const logoAllyContainer = document.getElementById("logo-ally-container");
        if (logoContainer) {
            logoContainer.innerHTML += logoContainer.innerHTML;
        }
        if (logoAllyContainer) {
            logoAllyContainer.innerHTML += logoAllyContainer.innerHTML;
        }
    }, []);

    return (
        <div className="d-flex flex-column gap-5 w-100 container py-5">
            <div className="logo-slider overflow-hidden position-relative mb-5">
                <div className="logo-track d-inline-block" id="logo-container">
                    {
                        Object.values(logos).map((logo, index) => (
                            <a key={index} href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                                <img src={logo.src} alt={logo.alt} className="mx-2 logo-img" />
                            </a>
                        ))
                    }

                    {
                        Object.values(logos).map((logo, index) => (
                            <a key={index} href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link" aria-hidden="true" tabIndex={-1}>
                                <img src={logo.src} alt={logo.alt} className="mx-2 logo-img" />
                            </a>
                        ))
                    }
                </div>
            </div>
            <div className="logo-slider overflow-hidden position-relative mb-5">
                <div className="logo-track d-inline-block" id="logo-ally-container">
                    {
                        Object.values(logos_ally).map((logo, index) => (
                            <a key={index} href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link" aria-hidden="true" tabIndex={-1}>
                                <img src={logo.src} alt={logo.alt} className="mx-2 logo-img" />
                            </a>
                        ))
                    }
                    {
                        Object.values(logos_ally).map((logo, index) => (
                            <a key={index} href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link" aria-hidden="true" tabIndex={-1}>
                                <img src={logo.src} alt={logo.alt} className="mx-2 logo-img" />
                            </a>
                        ))
                    }
                </div>
            </div>
            <div className="d-flex gap-2 justify-lg-content-between justify-content-center">
                <a href={logos_payments.logo_visa.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_payments.logo_visa.src} alt="Visa" className="payment-logo" />
                </a>
                <a href={logos_payments.logo_mastercard.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_payments.logo_mastercard.src} alt="Mastercard" className="payment-logo" />
                </a>
                <a href={logos_payments.logo_americanexpress.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                    <img src={logos_payments.logo_americanexpress.src} alt="American Express" className="payment-logo" />
                </a>
            </div>
            <div className="text-center">
                <p className="fs-5">Comunícate con alguna de nuestras empresas HOY.</p>
            </div>
        </div>
    );
}